import React from 'react';
import Sidebar from '../../core/common/sidebar/sidebar';
import DriverInfoSection from './DriverInfoSection';
import Breadcrumb from '../../core/common/Breadcrumb/breadcrumb';
import DriverSidebar from './sidebar';

const DriverDashboard = () => {
  const breadcrumbs = [
    { label: 'Dashboard', link: '/', active: false },
    { label: 'Motorista', active: true },
  ];

  return (
    <div>
      <Breadcrumb
        title="Dashboard do Motorista"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-01"
      />

      <div className="content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-4">
              <DriverSidebar />
            </div>

            {/* Conteúdo principal */}
            <div className="col-xl-9 col-lg-8">
              <div className="card shadow-none mb-0">
                <div className="card-header">
                  <h6>Dashboard do Motorista</h6>
                </div>
                <div className="card-body">
                  <DriverInfoSection />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverDashboard;
